import { useMutation, useQuery } from "@tanstack/react-query";
import { APIErrorResponse } from "src/types/generic";
import apiClient from "../apiClient";

interface IParams {
  page?: number;
}

export const useGetVendorsList = (params?: IParams) =>
  useQuery<any, APIErrorResponse, any>({
    queryKey: ["get-operation-cost-vendors-list", params?.page],
    queryFn: async () => {
      return apiClient.get(`/api/vendors`, { params: params || {} });
    },
  });

interface IVendorBody {
  id?: string;
  name?: string;
  start_balance?: number | string;
}

export const useAddVendorMutation = () =>
  useMutation<void, APIErrorResponse, IVendorBody>({
    mutationFn: async (data) => {
      return apiClient.post(`/api/vendors`, data);
    },
  });

export const useUpdateVendorMutation = () =>
  useMutation<void, APIErrorResponse, IVendorBody>({
    mutationFn: async (data) => {
      const { id, ...rest } = data;
      return apiClient.put(`/api/vendors/${id}`, rest);
    },
  });

export const useDeleteVendorMutation = () =>
  useMutation<void, APIErrorResponse, number>({
    mutationFn: async (id) => {
      return apiClient.delete(`/api/vendors/${id}`);
    },
  });
